import React from 'react';
import {
  StyledInaccessible,
  StyledInaccessibleContent,
  StyledInaccessibleImage,
  StyledInaccessibleWrapper,
  StyledInaccessibleHeader,
  StyledInaccessibleTextLink,
  FontWeightWrapper,
} from '../Styled';
import goat from '../../assets/goat.png';

export const AccessDenied: React.FC = (): JSX.Element => {
  const saveCurrentPath = (): void => {
    localStorage.setItem('path', location.pathname);
  };

  return (
    <StyledInaccessibleWrapper data-testid="access-denied">
      <StyledInaccessible height="300px">
        <StyledInaccessibleContent width="260px">
          <StyledInaccessibleHeader margin="0px 0px 16px 0px">Looking for access?</StyledInaccessibleHeader>
          <p>
            Your account currently <br /> doesn’t have access to this <br /> Big Book. To gain access, <br /> please
            &nbsp;
            <FontWeightWrapper weight={800}>
              <StyledInaccessibleTextLink to="/accesscode" tabIndex={0} onClick={saveCurrentPath}>
                enter the access code
              </StyledInaccessibleTextLink>
            </FontWeightWrapper>
            &nbsp; found inside the purchased printed Big Book.
          </p>
        </StyledInaccessibleContent>
        <StyledInaccessibleImage src={goat as string} alt="goat" height="312px" margin="26px 0px 0px -51px" />
      </StyledInaccessible>
    </StyledInaccessibleWrapper>
  );
};
